import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import Img from "gatsby-image"
import { VideoBg } from "../"

import './header-new.scss'

const CaseHeaderNew = ( { caseDomain, img, intl } ) => {
  const videoField = `cases.${ caseDomain }.vimeo`,
        videoId = intl.formatMessage( { id: videoField } )

  let video = null

  if( videoId !== videoField ) {
    video = <VideoBg title={ caseDomain } videoId={ videoId } />
  }

  return (
    <div className="case-header-new">
      <div className="description">
        <h1 className="title">
          { intl.formatMessage( { id: `cases.${ caseDomain }.title` } ) }
        </h1>
        <div className="objectives">
          { intl.formatMessage( { id: `cases.${ caseDomain }.objectives` } ) }
        <div className="areas">
          { intl.formatMessage( { id: `cases.${ caseDomain }.areas` } ) }
        </div>
      </div>
      </div>

      <div className="head-image">
        <Img fluid={ img } />
      </div>

      { video }
    </div>
  )
}

const injected = injectIntl( CaseHeaderNew )
export { injected as CaseHeaderNew }
